export const license = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    id: { en: 'License Key', ko: '라이선스 키', fr: '' },
    hospital: { en: 'Hospital', ko: '설치 병원', fr: '' },
    requestDate: { en: 'Request Date', ko: '요청 날짜', fr: '' },
    approvalDate: { en: 'Approval Date', ko: '승인 날짜', fr: '' },
    expirationDate: { en: 'Expiration Date', ko: '만료 날짜', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    meerkatSerial: { en: 'Meerkat Serial', ko: '미어캣 시리얼', fr: '' },
    cost: { en: 'Price', ko: '금액', fr: '' },
    info: { en: 'Info', ko: '기타', fr: '' },
    download: { en: 'Download', ko: '다운로드', fr: '' },
    select: { en: 'Select', ko: '선택', fr: '' },
    distributorCode: { en: 'Distributor code', ko: '대리점 코드', fr: '' },
    distributorName: { en: 'Distributor name', ko: '대리점명', fr: '' },
  },
  info: {
    expirationDate: { en: 'Expiration Date', ko: '만료 날짜', fr: '' },
    hospital: { en: 'Hospital', ko: '설치 병원', fr: '' },
    deviceLimit: { en: 'Device Limit', ko: '기기 제한', fr: '' },
    info: { en: 'Info', ko: '기타', fr: '' },
    id: { en: 'License Key', ko: '라이선스 키', fr: '' },
    requestDate: { en: 'Request Date', ko: '요청일', fr: '' },
    approvalDate: { en: 'Approval Date', ko: '승인일', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    meerkatSerial: { en: 'Meerkat Serial', ko: '미어캣 시리얼', fr: '' },
    download: { en: 'Download', ko: '다운로드', fr: '' },
    activateDate: { en: 'Activation Date', ko: '활성화 날짜', fr: '' },
    deactivateDate: { en: 'Deactivation Date', ko: '비활성화 날짜', fr: '' },
    downloadDate: { en: 'Download Date', ko: '다운로드 날짜', fr: '' },
    units: { en: 'units', ko: '수량', fr: '' },
    model: { en: 'model', ko: '모델', fr: '' },
    addDevice: { en: 'Add device', ko: '기기 추가', fr: '' },
    period: { en: 'Period', ko: '기간', fr: '' },
    today: { en: 'Today', ko: '오늘', fr: '' },
    totalCost: { en: 'Total Cost', ko: '총금액', fr: '' },
    week: { en: '7D', ko: '일주일', fr: '' },
    month: { en: '30D', ko: '한달', fr: '' },
    startDate: { en: 'start date', ko: '시작일', fr: '' },
    endDate: { en: 'end date', ko: '만료일', fr: '' },
    requested: { en: 'requested', ko: '요청', fr: '' },
    issued: { en: 'approved', ko: '승인', fr: '' },
    revoked: { en: 'revoked', ko: '반려', fr: '' },
    activated: { en: 'active', ko: '활성', fr: '' },
    deactivated: { en: 'deactivated', ko: '비활성', fr: '' },
    expired: { en: 'expired', ko: '만료', fr: '' },
    search: { en: 'Search', ko: '검색', fr: '' },
    reset: { en: 'Reset', ko: '초기화', fr: '' },
    placeholder: { en: 'search by id', ko: 'ID를 입력하세요.', fr: '' },
    hospitalDisplayName: { en: 'Display hospital name', ko: '표시 병원명', fr: '' },
    reqUserId: { en: 'Requester ID', ko: '요청자 ID', fr: '' },
    approve: { en: 'Approve', ko: '승인', fr: '' },
    askApprove: { en: 'Confirm approval?', ko: '승인하시겠습니까?', fr: '' },
    revoke: { en: 'Revoke', ko: '반려', fr: '' },
    askRevoke: { en: 'Confirm revoke?', ko: '반려하시겠습니까?', fr: '' },
    revokeDate: { en: 'Revoke Date', ko: '반려 날짜', fr: '' },
    revokeComment: { en: 'Revoke comment', ko: '반려 사유', fr: '' },
    addAllDevice: { en: 'Add All Models', ko: '모든 모델 추가', fr: '' },
  },
  placeHolder: {
    serial: { en: 'Serial', ko: '시리얼을 입력하세요', fr: '' },
    comment: { en: 'Comment', ko: '반려 사유를 입력하세요', fr: '' },
    id: { en: 'License Key', ko: '라이선스 키를 입력하세요', fr: '' },
    distributorCode: { en: 'Distributor Code', ko: '대리점 코드를 입력하세요', fr: '' },
  },
};
